/**
 * ネイティブ (Capacitor) のステータスバー・スプラッシュ制御。
 * Web/PWA では isNative() が false なので何もしない（Capacitor プラグインの Web 実装は
 * no-op に近いが、無駄な呼び出し自体を避ける）。
 * 設計: .steering/20260719-capacitor-store-app/design.md §6
 */
import { StatusBar, Style } from "@capacitor/status-bar";
import { SplashScreen } from "@capacitor/splash-screen";
import { isNative } from "./platform";

/**
 * アプリのテーマ（light/dark）に合わせてステータスバーの文字色を切り替える。
 * ThemeContext の theme が変わるたびに呼び出す。
 */
export function syncStatusBarStyle(theme: "light" | "dark"): void {
  if (!isNative()) return;
  StatusBar.setOverlaysWebView({ overlay: true }).catch(() => {});
  StatusBar.setStyle({ style: theme === "dark" ? Style.Dark : Style.Light }).catch(
    () => {},
  );
}

/**
 * 起動スプラッシュを隠す。capacitor.config.ts で launchAutoHide:false にしているため、
 * AuthProvider の初回セッション復元（isLoading）が終わったタイミングで明示的に呼ぶ。
 */
export function hideSplashScreen(): void {
  if (!isNative()) return;
  SplashScreen.hide().catch(() => {});
}
